import React, { useState, useEffect } from 'react';
import { Constants } from '../../Constants';

export const OrderIdTypeChoice = (props) => {

	const [orderIdTypePreferenceChosen, updateOrderIdTypePreferenceChosen] = useState(false);
	const [orderIdTypePreference, updateOrderIdTypePreference] = useState();
	const [selectedNewOrderIdPref, updateselectedNewOrderIdPref ] = useState("");

	// First, check if the user has already selected an order preference
	// that is stored in the database
	useEffect(()=>{
		var queryString = "/OrderID/checkIfOrderIdPreferenceExists?type=" + props.freightType;
		fetch(queryString) // TODO: Provide type argument
			.then(response => response.json())
			.then(data => updateOrderIdTypePreferenceChosen(data))
	}, [true]); // Setting the second argument to true like this makes the effect run just once

	// When the user's orderIdtypePReference is updated, get a new order ID 
	useEffect(() => {		
		if(props.dontAutoGenerateOnLoad){
			return;
		}
		getAutoGeneratedOrderIdViaApi();
	}, [orderIdTypePreferenceChosen]);

	const getAutoGeneratedOrderIdViaApi = () => {
		if(!orderIdTypePreferenceChosen){
			return;
		}
		var queryString = "/OrderID/generateOrderId?type=" + props.freightType;
		fetch(queryString)
			.then(response => response.text())
			.then(data => {
				props.onChangeId(data);
			})
	};

	const updateOrderIdPreference = (value) => {
		var queryString = "/OrderID/saveOrderIdTypePref?freightType=" + props.freightType + "&type=" + value;
		fetch(queryString)
			.then(response => response.json())
			.then(data => {
				updateOrderIdTypePreferenceChosen(data)
			});
	}

	return(
		<div className="col-12">
			<label name="freightPostingInputModel.orderID" className="control-label">Order ID</label>
			<div className="input-group">
				<input id="Order-Id-Value" required type="text" name="freightPostingInputModel.orderID" className="form-control" 
					value={props.currentOrderId} onChange={evt => props.onChangeId(evt.target.value)} />
				{/* {orderIdTypePreferenceChosen &&
					<div className="input-group-append">
						<input type="button" className="btn btn-success rounded-right" value="Generate ID"
							onClick={() => getAutoGeneratedOrderIdViaApi()}/>
					</div>
				} */}
			</div>
			{!orderIdTypePreferenceChosen &&
				<div className="row">
					<div className="col">
						<strong>You can choose to automatically generate order IDs</strong>
						<div className="form-check my-1">
							<input type="radio" id="Numeric-ID-Choice" className="form-check-input"
								name="orderIDChoice"
								defaultChecked
								onClick={() => updateselectedNewOrderIdPref(Constants.orderIDType.Number)}/>
							<label className="form-check-label" for="Numeric-ID-Choice">
								Number (1, 2, 3 ...)
							</label>
						</div>
						<div className="form-check mb-1">
							<input type="radio" id="Aplhabetic-ID-Choice" className="form-check-input"
								name="orderIDChoice"
								onClick={() => updateselectedNewOrderIdPref(Constants.orderIDType.Alphabetical)}/>
							<label className="form-check-label" for="Aplhabetic-ID-Choice">
								Aplhabet (A, B ... Z, AA, AB ...)
							</label>
						</div>
						<a type="button" className="btn btn-primary" onClick={() => updateOrderIdPreference(selectedNewOrderIdPref)}>Confirm ID type</a>
					</div>
				</div>
			}
		</div>
	)
	
}